<template>
  <vs-row
    class="select_row"
    vs-align="center"
    vs-type="flex"
    vs-justify="center"
    vs-w="12"
  >
    <p v-if="country__ == null" class="select_count">Select Country</p>
    <select
      v-model="country__"
      @click="
        (event) => {
          event.stopPropagation()
        }
      "
      @change="update_lead_details(params.data.leads_id)"
      name="cars"
      id="cars"
      form="carform"
      class="w-100 selectExample mt-2 customSelect"
    >
      <option
        :key="index"
        :value="item.id"
        :label="item.country_name"
        v-for="(item, index) in countryList"
        class="selectOptionclass"
      />
    </select>
  </vs-row>
</template>
<script>
import vSelect from 'vue-select'

import { leadDetailsApi } from '@/api/leaddetails'
import { update_lead_list } from '@/api/leads'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      country__: null,
      countryList: [],
      addDetailsModal: false,
      leadFullDetails: '',
      leadform: {},
      lead_id: [],
      oldCountryID: '',
      oldId: ''

    }
  },
  /*  created () {
  }, */
  mounted () {
    this.country__ = this.params.data.platform_customer_countries_id
    // this.fetchLeadDetails(this.params.data.leads_id)
    this.oldCountryID = this.params.data.platform_customer_countries_id
    this.countryList = this.params.colDef.filterParams
  },

  methods: {
    /*  async fetchLeadDetails (lead_ids) {
 
       try {
         const {data} = await leadDetailsApi(lead_ids)
         
         this.leadFullDetails = data.data.leads_details
         this.lead_id.push(lead_ids)
         
         this.$vs.loading.close()
 
       } catch (e) {
         
         this.$vs.loading.close()
 
       }
     }, */
    async update_lead_details (data) {
      this.leadform = {
        platform_customer_countries_id: this.country__
      }
      const payload = {
        leads_id: [data],
        update_field: this.leadform,
        customer_id: localStorage.getItem('customer_id')
      }
      try {
        if (this.params.data.actionData.toggle) {
          const { data } = await update_lead_list(payload)
          this.params.data.platform_customer_countries_id = this.country__
          const newCountry = this.countryList.filter(country => {
            return country.id === this.country__
          })

          this.params.data.country_details.country_name = newCountry[0].country_name
        } else {
          this.$vs.notify({
            title: "Warning",
            text: "Can\'t edit non actionable row",
            ...this.warnProp(),
          });
          return false
        }

        this.$vs.notify({
          title: 'Success',
          text: 'Updated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {

      }
    }
  }
}
</script>
<style scoped>
.customSelect {
  border-radius: 3px;
  border: 1px solid #cccccc;
  width: 100%;
  height: 30px;
  background-color: white;
  color: #757575;
  /* font-family: $font-family-base'; */
}
.selectOptionclass :hover {
  background-color: yellow;
  color: white;
  border: none;
}
</style>
